<template>
<!-- This example requires Tailwind CSS v2.0+ -->
<div class="fixed z-10 inset-0 overflow-y-auto" :class="showModal?'':'hidden'" aria-labelledby="modal-title" role="dialog" aria-modal="true">
  <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
    <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>

    <!-- This element is to trick the browser into centering the modal contents. -->
    <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

    <div class="max-w-2xl inline-block align-bottom bg-gray-700 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:w-full">

    <section class="border border-gray-800 p-3">
        <div class="flex justify-between">
            <h4 class="text-white text-sm font-bold uppercase mb-3">Create {{ featureName }} feature</h4>
            <button type="button" class="close" @click.prevent="closeModal">
              <span>&times;</span>
            </button>
        </div>
        <div class="errormessage-wraper">
            <span v-if="$page.props.errors" v-for="err in Object.values($page.props.errors)" class="errormessage font-bold">{{ err }}</span>
        </div>
    </section>

    <!-- Hidden for MVP -->
    <!-- <section class="border border-t-0 border-gray-800 p-3">
        <h4 class="text-white text-sm font-bold uppercase mb-3">
            Feature Type
        </h4>
        <button class="btn btn-black mt-2 mb-10 active">
            3D Model
        </button>
    </section> -->

    <div class="flex lang-box mt-5">
        <a v-for="(lang, index) in languages" href="#" @click.prevent="changeLanguage(lang)" :key="index"
        :class="{active:(form.current_language == lang), disabled:langDisabled(lang)}">{{ showFallbackLang(lang) }}</a>
    </div>

    <section class="border border-gray-800 p-3">
        <h4 class="text-white text-sm font-bold uppercase mb-3">
            Information
        </h4>
    </section>

    <section class="border border-gray-800 p-3">
        <h4 class="text-white text-sm font-bold uppercase mb-3">
            3d Model File
        </h4>

        <div class="grid grid-cols-2">
            <!-- GLB -->
            <div class="border border-t-0 border-l-0 border-gray-800">

                <div class="pr-4 pb-4">
                    <h5 class="text-white p-2">GLB</h5>
                    <div class="upload-box">
                        <span>
                            <i class="icon-upload mr-2"></i><a href="##" @click.prevent="changeUploadBoxState('augmented_reality_feature_glb')">Upload from media library</a>
                        </span>
                        <span>{{ threeDModelFileName('glb') }}</span>
                    </div>
                </div>
                <div class="pt-2 pb-4 pr-4 border-t border-gray-800">
                    <h5 class="text-white p-2">Scale in percentage</h5>
                    <input type="number" :value="scaleFactorValue()"
                    @change="handleChange" name="scale-factor" class="input-black" min="1">
                </div>
            </div>
            <!-- End GLB -->
            <!-- USDZ -->
            <div class="border border-t-0 border-x-0 border-gray-800">

                <div class="pl-4 pb-4">
                    <h5 class="text-white p-2">USDZ</h5>
                    <div class="upload-box">
                        <span>
                            <i class="icon-upload mr-2"></i><a href="##" @click.prevent="changeUploadBoxState('augmented_reality_feature_usdz')">Upload from media library</a>
                        </span>
                        <span>{{ threeDModelFileName('usdz') }}</span>
                    </div>
                </div>
                <div class="pt-2 pb-4 pl-4 border-t border-gray-800">
                    <h5 class="text-white p-2 font-bold">Loop animation</h5>
                    <div class="flex gap-3">
                        <input id="loop_animation_no" type="radio" name="loop_animation" value="loop_animation_no" @change="handleChange"
                        :checked="loopAnimationValueChecked('no')"
                        >
                        <label for="loop_animation_no" class="cursor-pointer">No</label>
                        <input id="loop_animation_yes" type="radio" name="loop_animation" value="loop_animation_yes" @change="handleChange"
                        :checked="loopAnimationValueChecked('yes')">
                        <label for="loop_animation_yes" class="cursor-pointer">Yes</label>
                    </div>
                </div>
            </div>
            <!-- End USDZ -->
            <!-- Marker -->
            <div class="border border-t-0 border-l-0 border-gray-800 pr-4 pb-4">

              <div class="form-switch mt-3">
                <input @change="handleChange" name="markerbased_ar"
                type="checkbox" id="markerbased_ar" :checked="markerbasedAr">
                <label for="markerbased_ar">Markerbased AR</label>
              </div>

              <div class="transition duration-300" :class="{ 'opacity-0 pointer-events-none': markerbasedAr == false }">
                <h5 class="text-white p-2">Marker</h5>
                <div class="upload-box">
                    <span v-if="!markerPath()">
                        <i class="icon-upload mr-2"></i><a href="##" @click.prevent="changeUploadBoxState('augmented_reality_feature_marker')">Upload from media library</a>
                    </span>
                    <img v-if="markerPath()" :src="markerPath()">
                </div>
              </div>

                <h5 class="text-white p-2 mt-3 font-bold">Position (cm) & Rotation</h5>
                <div class="pt-2 pb-4 border-b border-gray-800">
                    <ThreeNumbersInput
                    label="number-sign"
                    inputName="position"
                    :handleChange="handleChange"
                    :form="form"
                    />
                </div>
                <div class="pt-4 pb-2">
                    <ThreeNumbersInput
                    label="refresh-sign"
                    inputName="rotation"
                    :handleChange="handleChange"
                    :form="form"
                    />
                </div>

            </div>
            <!-- End Marker -->
            <!-- Audio -->
            <div class="border border-t-0 border-x-0 border-gray-800 pl-4 pb-4">

                <div class="form-switch mt-3">
                    <input type="checkbox" id="audio_switch"
                    @change="handleChange" name="audio" :checked="audioFile">
                    <label for="audio_switch">Audio</label>
                </div>

            <div class="transition duration-300" :class="{ 'opacity-0 pointer-events-none': audioFile == false }">
                <h5 class="text-white p-2">Audio file</h5>
                <div class="upload-box">
                    <span>
                        <i class="icon-upload mr-2"></i><a href="##" @click.prevent="changeUploadBoxState('augmented_reality_feature_audio')">Upload from media library</a>
                    </span>
                    <span>{{ audioFilePath() }}</span>
                </div>

                <div class="flex gap-3 mt-4 pb-2">
                    <h5 class="text-white font-bold">Loop</h5>
                    <input id="loop_audio_no" type="radio" name="loop_audio" value="loop_audio_no"
                    @change="handleChange" :checked="loopAudioValueChecked('no')">
                    <label for="loop_audio_no" class="cursor-pointer">No</label>
                    <input id="loop_audio_yes" type="radio" name="loop_audio" value="loop_audio_yes" @change="handleChange" :checked="loopAudioValueChecked('yes')">
                    <label for="loop_audio_yes" class="cursor-pointer">Yes</label>
                </div>

                <div class="border-t border-gray-800 py-4">
                    <h5 class="text-lg font-bold text-white">Volume</h5>
                    <div class="flex">
                        <div class="range-slider-wrapper">
                            <input v-model="this.form.general.volume_percentage" name="volume" type="range"
                            min="1" max="100" class="cursor-pointer">
                        </div>
                    <span class="text-white ml-3 text-lg">{{ this.form.general.volume_percentage }}</span>
                    </div>
                </div>
            </div>

            </div>
            <!-- End Audio -->
        </div>

        <div class="block text-center pt-3">
            <button v-if="!form.processing" class="btn btn-gradient" @click="saveFile"><i class="save"></i></button>
            <button v-else class="btn btn-gradient"><Spinner/></button>
        </div>

    </section>

    </div>
  </div>
</div>
</template>

<script>
import CreateFileInsideFeatureAudioSection from '@/Pages/Station/Partials/Features/AudioGuide/CreateFileInsideFeatureAudioSection';
import { showFallbackLang } from '@/Pages/GlobalHelpers';
import ThreeNumbersInput from './Partials/ThreeNumbersInput';
import Spinner from '@/UI/Spinner';

export default {
    components: {
        CreateFileInsideFeatureAudioSection,
        ThreeNumbersInput,
        Spinner
    },
    props: ['showModal', 'closeModal', 'featureName', 'changeUploadBoxState', 'form'],
    data(){
        return {
            languages: this.$page.props.tour.data.languages,
            markerbasedAr: true,
            audioFile: true,
        }
    },
    mounted(){
        this.changeLanguage(this.$page.props.tour.data.fallback_language);
    },
    methods: {
        saveFile() {
            this.form.post(route('augmentedrealityfeature.store', this.$page.props.station.data.id), {
              preserveScroll: true,
              onSuccess: () => this.closeModal(),
            });
        },
        changeLanguage(lang){
            if(this.langDisabled(lang))
            {
                return;
            }
            this.form.current_language = lang;
        },
        langDisabled(lang){
            if(lang == this.form.fallback_language)
            {
                return false;
            }

            if(
                this.form.languages[this.form.fallback_language].glb_file == null ||
                this.form.languages[this.form.fallback_language].usdz_file == null
            ) {
                return true;
            } else {
                return false;
            }
        },
        showFallbackLang:showFallbackLang,
        threeDModelFileName(threeDType){
            switch(threeDType){
                case 'glb':
                    return this.form.languages[this.form.current_language].glb_file;
                    break;
                case 'usdz':
                    return this.form.languages[this.form.current_language].usdz_file;
                    break;
            }
        },
        scaleFactorValue(){
            return this.form.general.scale_percentage;
        },
        loopAnimationValueChecked(inputValue){
            const value = this.form.general.animation_loop;
            if(value == false && inputValue == 'no')
            {
                return true;
            }
            if(value == true && inputValue == 'yes')
            {
                return true;
            }
            return false;
        },
        loopAudioValueChecked(inputValue){
            const value = this.form.general.loop_audio;
            if(value == false && inputValue == 'no')
            {
                return true;
            }
            if(value == true && inputValue == 'yes')
            {
                return true;
            }
            return false;
        },
        handleChange(e){
            if(e.target.name == 'scale-factor'){
                this.form.general.scale_percentage = e.target.value;
            }
            if(e.target.name == 'loop_animation') {
                switch(e.target.value) {
                    case 'loop_animation_yes':
                    this.form.general.animation_loop = true;
                    break;
                    case 'loop_animation_no':
                    this.form.general.animation_loop = false;
                    break;
                }
            }
            if(e.target.name == 'loop_audio') {
                switch(e.target.value) {
                    case 'loop_audio_yes':
                    this.form.languages[this.form.current_language].loop_audio = true;
                    break;
                    case 'loop_audio_no':
                    this.form.languages[this.form.current_language].loop_audio = false;
                    break;
                }
            }
            if(e.target.name.includes('position')) {
                if (/^[a-zA-Z]+$/.test(e.target.value))
                {
                    return
                }
                switch(e.target.name) {
                    case 'position_x':
                        this.form.general
                        .marker_position[0] = e.target.value;
                    break;
                    case 'position_y':
                        this.form.general
                        .marker_position[1] = e.target.value;
                    break;
                    case 'position_z':
                        this.form.general
                        .marker_position[2] = e.target.value;
                    break;
                }
            }
            if(e.target.name.includes('rotation')) {
                if (/^[a-zA-Z]+$/.test(e.target.value))
                {
                    return
                }
                switch(e.target.name) {
                    case 'rotation_x':
                        this.form.general
                        .marker_rotation[0] = e.target.value;
                    break;
                    case 'rotation_y':
                        this.form.general
                        .marker_rotation[1] = e.target.value;
                    break;
                    case 'rotation_z':
                        this.form.general
                        .marker_rotation[2] = e.target.value;
                    break;
                }
            }
            if(e.target.name == 'markerbased_ar') {
                this.markerbasedAr = e.target.checked;
            }
            if(e.target.name == 'audio') {
                this.audioFile = e.target.checked;
            }
        },
        markerPath() {
            if(this.form.general.marker_file != null)
            {
                return this.form.general.marker_file;
            }
            return false;
        },
        audioFilePath() {
            return this.form.languages[this.form.current_language].audio_file;
        }
    },
    watch:{
        markerbasedAr: function(newState, oldState){
            if(newState == false) {
                this.form.general.subtype = 'ar-markerless';
                this.form.general.marker_file = null;
            }
            if(newState == true) {
                this.form.general.subtype = 'ar-markerbased';
            }
        },
        audioFile: function(newState, oldState){
            if(newState == false) {
                setTimeout(() => {
                    this.form.general.with_audio = false;
                    this.form.languages[this.form.current_language].audio_file = null;
                }, 300);
            }
            if(newState == true) {
                setTimeout(() => {
                    this.form.general.with_audio = true;
                }, 300);
            }
        },
        'form.general.subtype': function(newState, oldState){
            if(newState == 'ar-markerbased' && this.markerbasedAr == false)
            {
                this.markerbasedAr = true;
            }
        },
        'form.general.with_audio': function(newState, oldState){
            if(newState == true)
            {
                this.audioFile = true;
            }
        }
    }
}
</script>
